module.exports = __webpack_public_path__ + "static/media/graham.49e56d80.png";